"use client";

import { Box } from "@mui/material";
import { useAppTheme } from "@/src/hooks/useAppTheme";
import { FONT_UI } from "@/src/components/common/broadsheet/tokens";

const EDITIONS = [
  { mode: "light" as const, label: "Day" },
  { mode: "dark" as const, label: "Night" },
];

const ThemeToggle = () => {
  const { theme, toggleTheme } = useAppTheme();

  return (
    <Box
      role="group"
      aria-label="Edition"
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        gap: 0.25,
        fontFamily: FONT_UI,
        fontSize: "0.6875rem",
        fontWeight: 600,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        lineHeight: 1.4,
      }}
    >
      {EDITIONS.map((edition, index) => {
        const active = theme === edition.mode;

        return (
          <Box
            key={edition.mode}
            sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.25 }}
          >
            {index > 0 ? (
              <Box
                component="span"
                aria-hidden="true"
                sx={{ color: "custom.inkMuted", opacity: 0.6 }}
              >
                ·
              </Box>
            ) : null}
            <Box
              component="button"
              type="button"
              aria-pressed={active}
              aria-label={`${edition.label} edition`}
              onClick={() => {
                if (!active) toggleTheme();
              }}
              sx={{
                font: "inherit",
                letterSpacing: "inherit",
                textTransform: "inherit",
                background: "none",
                border: 0,
                borderBottom: "1px solid",
                borderBottomColor: active ? "custom.kicker" : "transparent",
                p: 0,
                paddingBlock: "0.5rem",
                cursor: active ? "default" : "pointer",
                color: active ? "custom.kicker" : "custom.inkMuted",
                "&:hover": { color: "custom.kicker" },
              }}
            >
              {edition.label}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ThemeToggle;
